import { Resource } from "../resource/resource.model";

export class ChartInfo extends Resource{
    chartType: string;
    xAxis: string;
    yAxis: string;
}

export class AIReportResponse extends Resource {
    data: { [key: string]: any }[];
    chart?: ChartInfo;
}